import FeatherIcon from 'feather-icons-react';
import React from 'react';
import Badge from '../../../../components/base/Badge';
import './PaymentStatusBlock.scss';

interface IPaymentStatusBlockProps {
  status: string;
}

const PaymentStatusBlock: React.FunctionComponent<
  IPaymentStatusBlockProps
> = props => {
  const s = props.status;
  const bg =
    s === 'PAID'
      ? 'success'
      : s === 'WAITING' || s === 'POST_PAID'
      ? 'info'
      : 'secondary';
  const icon =
    s === 'PAID'
      ? 'check'
      : s === 'WAITING' || s === 'POST_PAID'
      ? 'clock'
      : 'info';

  return (
    <Badge
      bg={bg}
      variant="phoenix"
      iconPosition="end"
      className="fs-10"
      icon={<FeatherIcon icon={icon} size={12.8} className="ms-1" />}
    >
      {s}
    </Badge>
  );
};

export default PaymentStatusBlock;
